import {Pipe, PipeTransform} from '@angular/core';
import {CodebookModel} from '../models/codebook.model';
import {CategoryTypeCodebook} from '../codebook/category-type-codebook';

@Pipe({
    name: 'categoryType'
})
export class CategoryTypePipe implements PipeTransform {
    private allTypes:CodebookModel[] = CategoryTypeCodebook.allTypes;
    constructor() {
    }


    transform(value: any, args?: any): any {

        let  type = this.allTypes.filter(type => type.id === value)[0];
        if(type == null) {
            type = {id:-1,name:'n/a'}
        }
        return type.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/pipes/categoryType.pipe.ts